import React from "react";
import { Mars, Venus } from "lucide-react";

export default function GenderIcon({ gender, className = "h-4 w-4" }) {
  if (gender === "male") return <Mars className={`${className} text-blue-500`} aria-label="male" />;
  if (gender === "female") return <Venus className={`${className} text-pink-500`} aria-label="female" />;
  return null;
}
